<template>

  <div class="baseBackColor">

    <div class="p-d-flex p-p-3 card colorback border15">

      <div class="p-d-flex p-ai-center" >
        <div class="p-mr-2">
          <Button type="Button" class="go-back-button" @click="disable()">
            <i class="pi pi-chevron-left go-back-button-icon"></i>
          </Button>
          <span class="lbl-go-back">{{internalizationAboutPage.topBarReturnLabel}}</span>
        </div>
      </div>

      <div class="p-ml-auto if-container-padding">

        <IfInfo
          ifName="BANCO"
          v-bind:width="102"
          v-bind:height="38">
        </IfInfo>
        
      </div>
      
    </div>

    <div class="padd widthadjust positionAbs whiteback">

      <ImageFlexContainer class="marg" align='center'></ImageFlexContainer>

      <div class="p-d-flex p-jc-center marg">

        <template v-if="iconName == 'proposta'">
          <svg height="60" viewBox="0 0 79 57" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path :fill="fillIconColor" d="M70.5052 30.9971L78.4584 22.049L75.1032 18.0161L66.6529 27.4683L62.4277 23.4353C60.8122 21.923 58.0783 19.6544 56.3385 18.3942L49.1309 13.1009C46.6455 11.3365 42.6689 11.2105 40.0593 12.7228L37.4496 14.3612C37.2011 14.4872 36.9526 14.6133 36.704 14.6133C36.207 14.6133 35.5856 14.3612 35.3371 13.9831L34.7157 13.2269C34.5915 12.9749 34.4672 12.7228 34.4672 12.5968C34.4672 12.3447 34.5915 11.9666 34.9643 11.5886L42.7932 6.04325C43.166 5.79119 44.1602 5.41311 45.1543 5.41311C45.7757 5.41311 46.397 5.53914 46.7698 5.66517L53.1075 8.8159C54.226 9.32002 55.5929 9.69811 57.0841 9.69811C58.9482 9.69811 60.6879 9.19399 62.1792 8.31179L65.4102 6.29531L62.0549 2.3884L59.4453 4.02678C59.0725 4.27884 58.0783 4.5309 57.0841 4.5309C56.2143 4.5309 55.5929 4.40487 55.3444 4.15281L49.0067 1.00207C47.8882 0.497954 46.6455 0.245895 45.2786 0.245895C43.2903 0.245895 41.4263 0.750013 40.0593 1.75825L39.8108 1.88428L37.8225 1.1281C35.3371 -0.132194 31.609 -0.132194 28.9994 1.00207L24.6499 2.89252C24.0286 3.14457 23.1587 3.2706 22.1646 3.2706C21.2947 3.2706 20.3005 3.14457 19.6792 2.89252L17.3181 1.88428L13.8385 5.91722L17.6909 7.55561C20.1763 8.68988 24.0286 8.68988 26.6382 7.55561L30.9877 5.66517C31.4847 5.41311 32.3546 5.28708 33.2245 5.28708C33.7216 5.28708 34.4672 5.41311 34.9643 5.53914L32.2303 7.55561C30.6148 8.68988 29.6207 10.7063 29.6207 12.7228C29.6207 14.1091 29.9935 15.3694 30.8634 16.5037L31.4847 17.2599C33.473 19.9065 37.4496 20.6627 40.3078 19.0243L42.9175 17.3859C43.2903 17.1339 43.9116 17.0078 44.533 17.0078C45.4029 17.0078 46.1485 17.2599 46.397 17.5119L53.6046 22.8052C55.2201 23.9395 57.8298 26.082 59.1967 27.4683L67.5227 35.2821C67.8956 35.5342 67.8956 35.9123 67.8956 36.1643C67.8956 36.4164 67.8956 36.6684 67.5227 37.0465L66.9014 37.8027C66.5286 38.1808 65.9072 38.5589 65.1616 37.9287L53.2318 26.7121L49.7523 30.493L62.552 42.4658C62.8005 42.7179 62.9248 42.9699 62.9248 43.348C62.9248 43.6001 62.9248 43.8521 62.552 44.2302L61.9306 44.9864C61.4336 45.4905 60.6879 45.4905 60.1909 45.1124L48.2611 33.8958L44.7815 37.6767L55.4687 47.759C55.7172 48.0111 55.8415 48.2632 55.8415 48.6412C55.8415 49.0193 55.7172 49.2714 55.4687 49.5235L54.8473 50.2796C54.4745 50.6577 53.8532 51.0358 53.1075 50.2796L42.4204 40.3233L39.6865 43.222L38.9409 44.1042L44.6572 49.5235C44.9058 49.7755 45.0301 50.0276 45.0301 50.4057C45.0301 50.6577 45.0301 50.9098 44.6572 51.2879L44.0359 51.4139C43.6631 51.792 43.0417 52.1701 42.2961 51.5399L37.9467 47.507L37.3254 47.1289H37.2011C37.0768 45.6165 36.3312 44.2302 35.3371 43.222L34.5915 42.5918C33.5973 41.5836 32.2303 41.0795 30.8634 40.8274C30.4906 39.3151 29.4964 37.8027 29.1236 37.2986L28.378 36.6684C27.7567 36.0383 27.1353 35.6602 26.3897 35.4081C26.3897 35.0301 26.514 34.778 26.514 34.3999C26.514 32.6355 25.7684 30.9971 24.5257 29.7368L23.7801 29.1067C22.7859 28.0984 21.4189 27.4683 19.9277 27.3423C19.6792 26.082 19.0578 24.9477 18.0637 24.0655L17.3181 23.4353C15.2055 21.4189 11.726 21.1668 9.24058 22.9312L3.64847 18.1421L0.541748 21.797L5.76105 26.334L3.1514 29.1067C2.03298 30.2409 1.41163 31.8793 1.41163 33.5177C1.41163 35.2821 2.15724 36.9205 3.39994 38.1808L4.14555 38.8109C4.64263 39.3151 5.1397 39.5671 5.76105 39.9452C5.63678 40.5754 5.51251 41.2055 5.51251 41.8356C5.51251 43.6001 6.25812 45.2384 7.50081 46.4987L7.99789 47.0029C9.48912 48.3892 11.726 49.0193 13.7143 48.6412C14.0871 49.3974 14.4599 50.0276 15.0812 50.5317L15.8268 51.1618C17.5666 52.8002 20.3005 53.3043 22.5374 52.4221C22.7859 52.9263 23.1587 53.4304 23.6558 53.9345L24.4014 54.5646C26.7625 56.8332 30.9877 56.8332 33.3488 54.3126L35.5856 51.918L38.9409 55.0688C40.0593 56.203 41.6748 56.8332 43.2903 56.8332C45.0301 56.8332 46.7698 56.077 47.8882 54.8167L48.5096 54.0605C48.7581 53.8085 49.0067 53.4304 49.2552 53.0523L49.7523 53.4304C52.2377 55.6989 56.3385 55.5729 58.6996 53.0523L59.321 52.2961C59.9423 51.666 60.4394 50.7837 60.688 49.9015C62.6763 50.1536 64.416 49.2714 65.783 47.8851L66.4043 47.1289C67.5227 45.9946 68.1441 44.3562 68.1441 42.8439C68.1441 42.7179 68.1441 42.5918 68.1441 42.5918C69.1382 42.2137 70.1324 41.7096 70.878 40.9534L71.4994 40.1973C72.6178 39.063 73.2391 37.4246 73.2391 35.9123C73.2391 34.1478 72.4935 32.3834 71.2508 31.2492L70.5052 30.9971ZM32.1061 47.759C32.1061 48.0111 32.1061 48.3892 31.7333 48.6412L29.3722 50.9098C28.8751 51.4139 28.1295 51.4139 27.6324 50.9098L26.8868 50.2796C26.514 50.0276 26.514 49.6495 26.514 49.3974C26.514 49.1454 26.514 48.8933 26.8868 48.5152L29.2479 46.1207C29.4964 45.8686 29.745 45.7426 30.1178 45.7426C30.3663 45.7426 30.7391 45.7426 30.9877 46.1207L31.7333 46.7508C31.9818 47.1289 32.1061 47.381 32.1061 47.759ZM18.3122 45.2384L23.1587 40.1973C23.4072 39.9452 23.6558 39.8192 24.0286 39.8192C24.2771 39.8192 24.6499 39.8192 24.8985 40.1973L25.6441 40.8274C25.8926 41.0795 26.0169 41.3315 26.0169 41.7096C26.0169 41.9617 26.0169 42.2137 25.6441 42.5918L21.0461 47.381C20.6733 47.759 20.052 48.1371 19.3064 47.381L18.5608 46.7508C18.1879 46.4987 18.1879 46.1207 18.1879 45.8686C18.1879 45.6165 18.1879 45.3645 18.3122 45.2384ZM6.38239 33.5177C6.38239 33.2656 6.38239 32.8876 6.7552 32.6355L12.223 26.9642C12.8444 26.334 13.3415 26.334 13.9628 26.9642L14.4599 27.4683C14.7084 27.8464 14.957 28.3505 14.957 28.6025C14.957 28.8546 14.8327 29.1067 14.8327 29.1067L8.99204 35.1561C8.49496 35.5342 7.87362 35.4081 7.37654 35.0301L6.7552 34.3999C6.63093 34.1478 6.38239 33.7698 6.38239 33.5177ZM21.2947 34.2739C21.2947 34.5259 21.2947 34.904 20.9219 35.1561L13.0929 43.222C12.3473 43.9782 11.726 43.6001 11.3532 43.222L10.6075 42.5918C10.4833 42.3398 10.359 42.0877 10.359 41.7096C10.359 41.3315 10.4833 41.0795 10.7318 40.8274C18.0637 33.2656 18.5608 32.6355 18.5608 32.6355C18.9336 32.2574 19.5549 32.0053 20.3005 32.6355L21.0461 33.2656C21.2947 33.6437 21.2947 34.0218 21.2947 34.2739Z"/>
          </svg>
        </template>

        <template v-if="iconName == 'person'">
          <svg height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path :fill="fillIconColor" fill-rule="evenodd" clip-rule="evenodd" d="M30.0002 57.5C14.8124 57.5 2.50024 45.1878 2.50024 30C2.50024 14.8122 14.8124 2.5 30.0002 2.5C45.1881 2.5 57.5002 14.8122 57.5002 30C57.5002 45.1878 45.1881 57.5 30.0002 57.5ZM48.499 42.8114C51.0217 39.1756 52.5001 34.7604 52.5001 30C52.5001 17.5736 42.4265 7.49996 30.0001 7.49996C17.5737 7.49996 7.50011 17.5736 7.50011 30C7.50011 34.7606 8.97862 39.1759 11.5015 42.8118C14.315 39.0952 20.9267 37.5 30.0004 37.5C39.0737 37.5 45.6853 39.0951 48.499 42.8114ZM44.912 46.8492C44.1801 44.2183 38.9236 42.5 30.0004 42.5C21.0767 42.5 15.8201 44.2184 15.0886 46.8496C19.0586 50.3655 24.2801 52.5 30.0001 52.5C35.7204 52.5 40.9421 50.3653 44.912 46.8492ZM30.0004 15C23.9481 15 20.0004 19.3894 20.0004 25C20.0004 33.5684 24.4025 37.5 30.0004 37.5C35.5456 37.5 40.0004 33.699 40.0004 25.5C40.0004 19.8039 36.0359 15 30.0004 15ZM25.0002 25C25.0002 30.6732 27.0458 32.5 30.0002 32.5C32.9445 32.5 35.0002 30.746 35.0002 25.5C35.0002 22.3761 33.0394 20 30.0002 20C26.8346 20 25.0002 22.0396 25.0002 25Z"/>
          </svg>
        </template>

      </div>

      <slot></slot>

    </div>

  </div>

</template>

<script>
import { getInternalization } from '@/util/util.js';

/* Internalization, used if not use BD to get data 
var internalizationAboutPageTmp = {

  "topBarReturnLabel": "Voltar",

}
/* */

export default {
  props: {
    showOBIcon: Boolean,
    iconName: String
  },
  data(){
    return {
      fillIconColor: 'var(--aboutobcarousel-icon-color)',
    }
  },
  methods: {
    disable(){
      this.$emit('disable');
    }
  },
  created(){
    this.internalizationAboutPage = getInternalization();
  }
}
</script>

<style scoped>
.baseBackColor{
  background-color: var(--page-background-color);
  border-radius: 15px;
}
.colorback {
  background-color:var(--navbar-background-color);
}
.border15 {
  border-radius: 15px 15px 0px 0px;
}
.marg {
  margin: 10px 0px 10px 0px;
}
.padd {
  padding: 0px 20px 20px 10px;
}
.widthadjust {
  height: 100%;
  width: 100%;
}
.positionAbs {
  position: relative;
}
.whiteback {
  background-color: var(--page-background-color);
  border-radius: 0px 0px 15px 15px;
}
.go-back-button {
  background-color: var(--others-no-background);
  background-repeat: no-repeat;
  color: var(--navbar-go-back-button-color);
  border: none;
  cursor: pointer;
  overflow: hidden;
  outline: none;
  padding: 0.5em;
  vertical-align: middle;
}
.go-back-button-icon {
  font-size: 1.5rem
}
.lbl-go-back
{
  vertical-align: middle;
  color: var(--navbar-go-back-button-text-color);
  font-weight: bold;
  margin-left: 5px;
}
</style>